import { render, staticRenderFns } from "./loginLink.vue?vue&type=template&id=48ba934f&scoped=true&"
import script from "./loginLink.vue?vue&type=script&lang=js&"
export * from "./loginLink.vue?vue&type=script&lang=js&"
import style0 from "./loginLink.vue?vue&type=style&index=0&id=48ba934f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ba934f",
  null
  
)

export default component.exports